import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Sidebar.css';
import { useTheme } from '../context/ThemeContext';
import { useLanguage } from '../context/LanguageContext';
import languages from '../config/languages';

const Sidebar = ({ isOpen, onClose }) => {
    const navigate = useNavigate();
    const { theme, toggleTheme } = useTheme();
    const { language, setLang } = useLanguage();
    const [langOpen, setLangOpen] = useState(false);
    const dropdownRef = useRef(null);

    const current = languages.find(l => l.code === language);

    useEffect(() => {
        const handler = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setLangOpen(false);
            }
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    const navTo = (path) => {
        navigate(path);
        onClose();
    };

    return (
        <div className={`sidebar ${isOpen ? 'open' : ''}`}>
            <button className="close-btn" onClick={onClose}>×</button>
            <h2>Menu</h2>
            <ul>
                <li><span onClick={() => navTo('/')}>Home</span></li>
                <li><span onClick={() => navTo('/github-projects')}>GitHub Projects</span></li>
                <li><span onClick={() => navTo('/darija')}>Darija</span></li>
            </ul>

            <div className="sidebar-bottom">
                <button
                    onClick={toggleTheme}
                    className="theme-switch"
                    title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
                    aria-label="Toggle theme"
                >
                    <span className="theme-switch-icon">{theme === 'dark' ? '🌙' : '☀️'}</span>
                    <span className={`theme-switch-track ${theme === 'light' ? 'theme-switch-track--on' : ''}`}>
                        <span className="theme-switch-thumb" />
                    </span>
                </button>

                <div className="lang-dropdown" ref={dropdownRef}>
                    <button
                        className={`lang-dropdown-btn ${langOpen ? 'lang-dropdown-btn--open' : ''}`}
                        onClick={() => setLangOpen(o => !o)}
                        aria-label="Select language"
                    >
                        <img src={current.flag} alt={current.label} className="lang-flag" />
                        <span className="lang-label">{current.label}</span>
                        <span className="lang-chevron">▾</span>
                    </button>

                    {langOpen && (
                        <div className="lang-dropdown-menu">
                            {languages.map(lang => (
                                <button
                                    key={lang.code}
                                    className={`lang-option ${lang.code === language ? 'lang-option--active' : ''}`}
                                    onClick={() => { setLang(lang.code); setLangOpen(false); }}
                                >
                                    <img src={lang.flag} alt={lang.label} className="lang-flag" />
                                    <span>{lang.label}</span>
                                    {lang.code === language && <span className="lang-check">✓</span>}
                                </button>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Sidebar;
